export default {
  news: {
    name: 'ข่าว',
    fields: {
      thumbnail_path: 'ภาพตัวอย่าง',
      thumbnail: 'ภาพตัวอย่าง',
      title_th: 'หัวข้อข่าว (ไทย)',
      title_en: 'หัวข้อข่าว (อังกฤษ)',
      title: 'หัวข้อข่าว (ไทย/อังกฤษ)',
      description: 'เนื้อหาข่าว',
      description_th: 'เนื้อหาข่าว (ไทย)',
      description_en: 'เนื้อหาข่าว (อังกฤษ)',
      short_description: 'เนื้อหาข่าวโดยย่อ',
      short_description_th: 'เนื้อหาข่าวโดยย่อ (ไทย)',
      short_description_en: 'เนื้อหาข่าวโดยย่อ (อังกฤษ)',
      start: 'เริ่มต้น',
      end: 'สิ้นสุด',
      highlight: 'ข่าวเด่น',
      type: { label: 'ประเภท', choices: { common: 'ส่วนกลาง', branch: 'สาขา' } },
      attachment_helper: 'อนุญาตเฉพาะไฟล์สกุล pdf ขนาดไม่เกิน 5mb สูงสุด 15 ไฟล์',
      attachment: 'ไฟล์แนบ',
      thumbnail_path_helper: 'รูปภาพตัวอย่าง',
      cover: 'รูปภาพพื้นหลัง',
      images: 'รูปภาพประกอบ',
      images_helper: 'อนุญาตเฉพาะไฟล์สกุล jpg, png, jpeg ขนาดไม่เกิน 2mb สูงสุด 15 ไฟล์',
      notification: 'แจ้งเตือน',
      // note: 'คอนเทนท์ของคุณจะยังไม่ถูกเผยแพร่จนกว่าจะได้รับการอนุมัติ',
      note: '',
      no_image: 'ไม่มีภาพตัวอย่าง',
    },
    create: { title: 'สร้างข่าว' },
    edit: { title: 'แก้ไขข่าว' },
    order: { title: 'จัดการลำดับข่าว' },
    highlight: { title: 'ข่าวเด่น' },
    approved: { title: 'ข่าวที่อนุมัติ' },
    published: { title: 'ข่าวที่เผยแพร่' },
    viewer: {
      guest: 'ผู้ใช้ทั่วไป',
      branch: 'name_th',
      from: 'ผู้เข้าชมจาก',
      views: 'จำนวนผู้เข้าชม',
      all_views: 'ยอดเข้าชมทั้งหมด',
    },
  },
}
